import { DEAL_STAGES, formatINRShort } from "@/lib/constants";

// Warm brand gradient that narrows down the funnel; Order Won lands in success-green.
const SEGMENT_COLORS = ["#5b1712", "#7c1d17", "#a3231b", "#cf2f23", "#f04935", "#f97a6d", "#10b981"];
const wpct = (r, max) => 36 + 64 * (max ? r / max : 0); // min 36%, max 100%

export function PipelineFunnel({ dealsByStage }) {
  const stages = DEAL_STAGES.filter((s) => s !== "Order Lost").map((s) => ({
    name: s,
    count: dealsByStage?.[s]?.count || 0,
    value: dealsByStage?.[s]?.value || 0,
  }));
  // Cumulative reach: deals at or beyond a stage → produces a true narrowing funnel.
  const reach = stages.map((_, i) => stages.slice(i).reduce((a, s) => a + s.count, 0));
  const reachValue = stages.map((_, i) => stages.slice(i).reduce((a, s) => a + s.value, 0));
  const max = Math.max(reach[0], 1);
  const empty = reach[0] === 0;

  return (
    <div data-testid="pipeline-funnel">
      {empty ? (
        <p className="text-sm text-slate-400 text-center py-16">No active deals in the pipeline yet.</p>
      ) : (
        <div className="space-y-0">
          {stages.map((st, i) => {
            const topW = wpct(reach[i], max);
            const botW = wpct(reach[i + 1] ?? reach[i] * 0.78, max);
            const conv = i > 0 && reach[i - 1] ? Math.round((reach[i] / reach[i - 1]) * 100) : null;
            const clip = `polygon(${(100 - topW) / 2}% 0, ${(100 + topW) / 2}% 0, ${(100 + botW) / 2}% 100%, ${(100 - botW) / 2}% 100%)`;
            return (
              <div key={st.name} className="flex items-stretch gap-3 group" style={{ height: 48 }} data-testid={`funnel-stage-${i}`}>
                <div className="w-36 flex flex-col justify-center text-right shrink-0">
                  <span className="text-xs font-medium text-slate-700 leading-tight truncate">{st.name}</span>
                  {conv !== null && <span className="text-[10px] text-slate-400">{conv}% from prev</span>}
                </div>
                <div className="flex-1 relative">
                  <div
                    className="absolute inset-0 transition-transform duration-200 group-hover:scale-[1.015]"
                    style={{ clipPath: clip, background: SEGMENT_COLORS[i], boxShadow: "inset 0 1px 0 rgba(255,255,255,.18)" }}
                  />
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <span className="text-white text-sm font-bold tabular-nums drop-shadow-sm">{reach[i]}</span>
                  </div>
                </div>
                <div className="w-20 flex items-center justify-end shrink-0">
                  <span className="text-xs font-mono font-semibold text-slate-600">{formatINRShort(reachValue[i])}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
